﻿/* =========================================================
   PTAH APP вЂ” cart, drawer, motion, bulk calculator
   ========================================================= */
(function () {
  'use strict';

  // Shopify CDN prefix (injected by theme.liquid). Falls back to 'assets/' for static hosting.
  var _cdnBase = window.SHOPIFY_CDN !== undefined ? window.SHOPIFY_CDN : 'assets/';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money formatting ---------- */
  const money = (cents) => '$' + (cents / 100).toFixed(2);
  window.PTAH_money = money;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; document.body.appendChild(el); }
    el.textContent = msg;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2400);
  }
  window.PTAH_toast = toast;

  /* ---------- Cart (localStorage) ---------- */
  const CART_KEY = 'ptah_cart_v1';
  const FREE_SHIP_THRESHOLD = 15000; // $150

  /* ---------- Shopify checkout (cart-permalink, no API keys) ----------
     РЎР°РјС‹Р№ РЅР°РґС‘Р¶РЅС‹Р№ СЃРїРѕСЃРѕР± РїРѕРґРєР»СЋС‡РёС‚СЊ РѕРїР»Р°С‚Сѓ Shopify Рє РєР°СЃС‚РѕРјРЅРѕРјСѓ СЃР°Р№С‚Сѓ:
     СЃСЃС‹Р»РєР° РІРёРґР°  https://Р’РђРЁ-РњРђР“РђР—РРќ.myshopify.com/cart/VARIANT:QTY,...
     РѕС‚РєСЂС‹РІР°РµС‚ РєРѕСЂР·РёРЅСѓ Shopify СѓР¶Рµ Р·Р°РїРѕР»РЅРµРЅРЅРѕР№ Рё РІРµРґС‘С‚ РЅР° РµРіРѕ checkout
     (РєР°СЂС‚С‹, Apple/Google Pay, РЅР°Р»РѕРіРё, РґРѕСЃС‚Р°РІРєР° вЂ” РІСЃС‘ РЅР° СЃС‚РѕСЂРѕРЅРµ Shopify).

     Р§РўРћ Р—РђРџРћР›РќРРўР¬ (СЃРј. SHOPIFY_SETUP.txt):
     1) domain вЂ” РїРѕРґРґРѕРјРµРЅ РІР°С€РµРіРѕ РјР°РіР°Р·РёРЅР° .myshopify.com
     2) Сѓ РєР°Р¶РґРѕРіРѕ С‚РѕРІР°СЂР° РІ РµРіРѕ С„РѕСЂРјРµ РїСЂРѕСЃС‚Р°РІРёС‚СЊ data-shopify-variant="Р§РРЎР›Рћ"
        (С‡РёСЃР»РѕРІРѕР№ ID РІР°СЂРёР°РЅС‚Р° РёР· Shopify). РўРѕРіРґР° РєРЅРѕРїРєР° Checkout РІРµРґС‘С‚
        РїСЂСЏРјРѕ РІ РѕРїР»Р°С‚Сѓ Shopify. РџРѕРєР° domain РїСѓСЃС‚РѕР№ вЂ” СЂР°Р±РѕС‚Р°РµС‚ РїСЂРµРІСЊСЋ-СЂРµР¶РёРј. */
  const SHOPIFY_CONFIG = {
    domain: '' // РЅР°РїСЂ. 'ptah-apparel.myshopify.com'
  };


  /* в”Ђв”Ђ Pricing engine (PDF Catalog) в”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђв”Ђ */
  const RETAIL_MAX_QTY = 25;
  const GARMENT_TABLE = {
    'tee-oversized-box-75':      [24,22,20,18,17],
    'tee-unisex-heavyweight-75': [22,20,18,17,16],
    'tee-oversized-casual-wash': [21,20,19,18,16],
    'tee-freestyler-71':         [19,17,16,15,14],
    'ls-oversized-box':          [36,34,32,31,30],
    'ls-unisex-heavyweight':     [34,32,30,29,28],
    'ls-oversized-casual-wash':  [31,30,28,26,25],
    'ls-freestyler-71':          [28,26,25,23,21],
    'crew-oversized-15':         [65,62,60,57,50],
    'crew-unisex-13':            [56,53,50,48,45],
    'crew-oversized-casual-wash':[50,48,45,43,40],
    'crew-freestyler-11':        [48,44,40,37,35],
    'hoodie-oversized-heavy-15': [70,65,60,58,55],
    'hoodie-unisex-13':          [68,65,62,60,55],
    'hoodie-oversized-casual':   [65,60,58,55,52],
    'hoodie-freestyler-11':      [60,58,56,53,50],
    'zip-oversized-heavy-15':    [75,70,65,62,58],
    'zip-unisex-13':             [70,67,63,60,56],
    'zip-oversized-casual':      [67,65,60,57,55],
    'zip-unisex-heavyweight-11': [65,63,61,58,55],
    'polo-classic-30':           [30,28,26.5,25,23.5]
  };
  // Volume curve averaged from Rostik's PDF (applies to any item without
  // its own PDF row): tier price = retail × multiplier, rounded to 50¢.
  const TIER_MULT = [1.00, 0.94, 0.89, 0.84, 0.79];
  const tierFromRetail = (retail) => TIER_MULT.map(m => Math.round(retail * m * 2) / 2);
  const fmtPrice = (v) => Number.isInteger(v) ? String(v) : v.toFixed(2);
  const PRINT_TABLE = {
    dtf:        { A6:[9,8,7,6,5], A5:[14,12,11,10,8], A4:[20,17,15,12,10], 'A3+':[24,20,18,16,14] },
    embroidery: { small:[12,10,9,8,7], medium:[20,18,16,14,12], large:[30,27,24,21,18], back:[55,48,42,36,32] },
    vinyl:      { A6:[8,7,6,5,4], A5:[13,11,10,8,7], A4:[20,18,16,14,12], 'A3+':[32,28,24,20,18] }
  };
  // Lower-inclusive tiers: qty 25 = the "25–50" tier (matches pickTier in
  // the bulk calc and how the pricing tables read; boundary qty gets the
  // better volume price).
  function tierIndex(q) { return q<10?0:q<25?1:q<50?2:q<100?3:4; }
  const garmentData = {
    'tee-box':      { name: 'Oversized Box S/S Tee · 7.5oz',    specs: '7.5oz · 100% cotton · Boxy fit · Made in Seattle',        tableKey: 'tee-oversized-box-75' },
    'tee-drop':     { name: 'Drop Crop S/S Tee · 7.0oz',         specs: '7.0oz · 100% cotton · Cropped fit · Made in Seattle',      tableKey: 'tee-freestyler-71' },
    'tee-daily':    { name: 'Daily S/S Tee · 6.5oz',             specs: '6.5oz · 100% cotton · Everyday fit · Made in Seattle',     tableKey: 'tee-unisex-heavyweight-75' },
    'tee-tour':     { name: 'Tour S/S Tee · 6.0oz',              specs: '6.0oz · 100% cotton · Lightweight · Made in Seattle',      tableKey: 'tee-freestyler-71' },
    'tee-wash':     { name: 'Casual Wash Tee · Enzyme Washed',    specs: 'Enzyme washed · 100% cotton · Relaxed fit · Made in Seattle', tableKey: 'tee-oversized-casual-wash' },
    'ls-box':       { name: 'Oversized Box Long Sleeve · 7.5oz', specs: '7.5oz · 100% cotton · Boxy fit · Made in Seattle',        tableKey: 'ls-oversized-box' },
    'ls-heavy':     { name: 'Heavyweight Long Sleeve',                specs: '9oz · 100% cotton · Ribbed cuffs · Made in Seattle',      tableKey: 'ls-unisex-heavyweight' },
    'sweat-15':     { name: 'Oversized Crew 15oz',                    specs: '15oz · 100% cotton · Brushed inside · Made in Seattle',   tableKey: 'crew-oversized-15' },
    'sweat-13':     { name: 'Heavyweight Crew 13oz',                  specs: '13oz · 100% cotton · Standard fit · Made in Seattle',     tableKey: 'crew-unisex-13' },
    'hoodie-14':    { name: 'Heavy Hoodie · 14oz',                specs: '14oz · 100% cotton · Drop-shoulder · Made in Seattle',    tableKey: 'hoodie-unisex-13' },
    'hoodie-15':    { name: 'Oversized Heavy Hoodie 15oz',            specs: '15oz · 100% cotton · Oversized · Made in Seattle',        tableKey: 'hoodie-oversized-heavy-15' },
    'hoodie-casual':{ name: 'Casual Wash Hoodie',                     specs: 'Enzyme washed · 100% cotton · Relaxed · Made in Seattle', tableKey: 'hoodie-oversized-casual' },
    'zip-11':       { name: 'Zip Hoodie · 11oz',                  specs: '11oz · 100% cotton · Metal zip · Made in Seattle',        tableKey: 'zip-unisex-heavyweight-11' },
    'zip-15':       { name: 'Oversized Heavy Zip-Hoodie 15oz',        specs: '15oz · 100% cotton · Metal zip · Made in Seattle',        tableKey: 'zip-oversized-heavy-15' },
    'cap-mesh':     { name: 'PTAH Mesh Snapback',                     specs: '6-panel · structured · snapback · Made in Seattle',       tableKey: null, fixedPrice: 20 },
    'cap-ptah':     { name: 'PTAH Structured Snapback',               specs: 'Structured front · snapback · Made in Seattle',               tableKey: null, fixedPrice: 10 },
    'polo':         { name: 'Classic Pique Polo',                     specs: 'Pique cotton · Classic fit · Front & back print · Made in Seattle', tableKey: 'polo-classic-30' }
  };
  function shopifyCheckoutURL() {
    const items = getCart();
    if (!SHOPIFY_CONFIG.domain || !items.length) return null;
    const parts = items
      .filter(i => i.variantId)
      .map(i => `${i.variantId}:${i.qty}`);
    if (parts.length !== items.length) return null; // РЅРµ Сѓ РІСЃРµС… СЃС‚СЂРѕРє РµСЃС‚СЊ variantId
    return `https://${SHOPIFY_CONFIG.domain}/cart/${parts.join(',')}`;
  }

  function getCart() {
    try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; }
    catch { return []; }
  }
  function setCart(items) { localStorage.setItem(CART_KEY, JSON.stringify(items)); }
  function cartCount() { return getCart().reduce((s, i) => s + i.qty, 0); }
  function cartTotal() { return getCart().reduce((s, i) => s + i.price * i.qty, 0); }

  function addToCart(item) {
    const items = getCart();
    items.push({ ...item, id: 'l_' + Date.now().toString(36) });
    setCart(items);
    refreshCartUI();
  }

  function removeLine(lineId) {
    setCart(getCart().filter(i => i.id !== lineId));
    refreshCartUI();
  }

  function updateLineQty(lineId, qty) {
    const items = getCart();
    const line = items.find(i => i.id === lineId);
    if (!line) return;
    line.qty = Math.max(0, qty);
    if (line.qty === 0) {
      setCart(items.filter(i => i.id !== lineId));
    } else {
      setCart(items);
    }
    refreshCartUI();
  }

  function renderCartDrawer() {
    const body = $('[data-cart-body]');
    if (!body) return;
    const items = getCart();
    const total = cartTotal();
    const remaining = FREE_SHIP_THRESHOLD - total;
    const progress = Math.min(100, total * 100 / FREE_SHIP_THRESHOLD);

    if (!items.length) {
      body.innerHTML = `
        <div class="cart-empty">
          <h3 class="cart-empty__title">Your cart is empty.</h3>
          <p class="t-small">Browse the catalog to get started.</p>
          <a href="shop.html" class="btn btn--primary btn--sm" data-drawer-close style="margin-top:24px;">Shop</a>
        </div>`;
      $('[data-cart-foot]').innerHTML = '';
      return;
    }

    let html = '';
    if (remaining > 0) {
      html += `<div class="cart-progress">
        Add <strong>${money(remaining)}</strong> more for free U.S. shipping
        <div class="cart-progress__bar"><div class="cart-progress__fill" style="width:${progress}%"></div></div>
      </div>`;
    } else {
      html += `<div class="cart-progress" style="border-left:2px solid var(--bronze);text-align:left;padding-left:16px;">
        <strong style="color:var(--bronze);">Free U.S. shipping unlocked</strong>
      </div>`;
    }

    html += items.map(line => `
      <div class="cart-item" data-line="${line.id}">
        <div class="cart-item__img">
          ${line.image ? `<img src="${line.image}" alt="">` : '<div></div>'}
        </div>
        <div class="cart-item__info">
          <div class="cart-item__title">${line.title}</div>
          ${line.variant ? `<div class="cart-item__variant">${line.variant}</div>` : ''}
          ${line.method ? `<div class="cart-item__variant" style="color:var(--bronze);">+ ${line.method}${line.printSize ? ' · Print ' + line.printSize + '%' : ''}</div>` : ''}
          <div class="cart-item__price">${money(line.price * line.qty)}</div>
          <div class="cart-item__actions">
            <div class="qty">
              <button type="button" class="qty__btn" data-line-minus aria-label="Decrease">в€’</button>
              <input type="number" class="qty__input" value="${line.qty}" min="0" max="999" readonly>
              <button type="button" class="qty__btn" data-line-plus aria-label="Increase">+</button>
            </div>
            <button type="button" class="cart-item__remove" data-line-remove>Remove</button>
          </div>
        </div>
      </div>`).join('');

    html += `
      <div class="cart-summary">
        <div class="cart-summary__row"><span>Subtotal</span><span class="v">${money(total)}</span></div>
        <div class="cart-summary__row t-small"><span>Shipping</span><span>${remaining > 0 ? 'At checkout' : 'Free'}</span></div>
        <div class="cart-summary__row cart-summary__row--total"><span>Total</span><span class="v">${money(total)}</span></div>
      </div>`;

    body.innerHTML = html;

    $('[data-cart-foot]').innerHTML = `
      <button type="button" class="btn btn--primary btn--full btn--lg" data-cart-checkout>
        Checkout · ${money(total)}
      </button>
      <p class="t-small text-center" style="margin-top:12px;letter-spacing:0.06em;">30-day returns · Made-to-order · Free U.S. shipping over $150</p>`;

    const checkoutBtn = $('[data-cart-checkout]', $('[data-cart-foot]'));
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', () => {
        const url = shopifyCheckoutURL();
        if (url) {
          if (window.dataLayer) window.dataLayer.push({ event: 'begin_checkout', value: total / 100 });
          window.location.href = url; // в†’ РѕРїР»Р°С‚Р° Shopify
        } else if (!SHOPIFY_CONFIG.domain) {
          toast('Checkout Р°РєС‚РёРІРёСЂСѓРµС‚СЃСЏ РїРѕСЃР»Рµ РїРѕРґРєР»СЋС‡РµРЅРёСЏ Shopify (СЃРј. SHOPIFY_SETUP)');
        } else {
          toast('РќРµ Сѓ РІСЃРµС… С‚РѕРІР°СЂРѕРІ Р·Р°РґР°РЅ Shopify variant ID');
        }
      });
    }

    // Bind line events
    $$('[data-line]', body).forEach(row => {
      const id = row.dataset.line;
      $('[data-line-minus]', row).addEventListener('click', () => {
        const cur = parseInt($('.qty__input', row).value, 10);
        updateLineQty(id, cur - 1);
      });
      $('[data-line-plus]', row).addEventListener('click', () => {
        const cur = parseInt($('.qty__input', row).value, 10);
        updateLineQty(id, cur + 1);
      });
      $('[data-line-remove]', row).addEventListener('click', () => removeLine(id));
    });
  }

  function refreshCartUI() {
    $$('[data-cart-count]').forEach(el => {
      const c = cartCount();
      el.textContent = c;
      el.setAttribute('data-count', c);
    });
    renderCartDrawer();
  }

  /* ---------- Drawers ---------- */
  function bindDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    const overlay = $(`.drawer-overlay[data-target="${id}"]`);
    const open = () => {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('no-scroll');
    };
    const close = () => {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    };
    // Toggle, not just open: with the burger now morphing into an X (see
    // assets/animations.js initBurgerMorph + the .burger styles), tapping
    // that same button while the drawer is open has to close it -- otherwise
    // the icon LOOKS like a close button but does nothing when tapped, which
    // reads as broken. Single trigger per drawer (verified: one burger, one
    // cart icon), so this can't race against a second opener.
    const toggle = () => { (drawer.classList.contains('is-open') ? close : open)(); };
    $$(`[data-drawer-open="${id}"]`).forEach(b => b.addEventListener('click', toggle));
    $$('[data-drawer-close]', drawer).forEach(b => b.addEventListener('click', close));
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    return { open, close };
  }

  /* ---------- Collapsibles ---------- */
  function bindCollapses() {
    $$('.collapse__trigger, .faq__trigger').forEach(t => {
      t.addEventListener('click', () => {
        const item = t.closest('.collapse') || t.closest('.faq__item');
        const open = item.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open);
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function bindQty() {
    $$('.qty').forEach(qty => {
      if (qty.dataset.bound) return;
      qty.dataset.bound = '1';
      const input = $('.qty__input', qty);
      if (!input || input.readOnly) return;
      const minus = $('[data-qty-minus]', qty);
      const plus = $('[data-qty-plus]', qty);
      const min = parseInt(input.min || '1', 10);
      const max = parseInt(input.max || '999', 10);
      const change = (d) => {
        const v = Math.max(min, Math.min(max, parseInt(input.value, 10) + d));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      };
      minus && minus.addEventListener('click', () => change(-1));
      plus && plus.addEventListener('click', () => change(1));
    });
  }

  /* ---------- Variant picker (PDP) ---------- */
  class VariantPicker {
    constructor(root) {
      this.root = root;
      this.bind();
    }
    bind() {
      $$('[data-opt]', this.root).forEach(input => {
        input.addEventListener('change', () => this.onChange());
      });
    }
    onChange() {
      $$('.variant-group', this.root).forEach(group => {
        const checked = $('[data-opt]:checked', group);
        const display = $('.value', group);
        if (display && checked) display.textContent = checked.value;
      });
    }
  }

  /* ---------- PTAH Live Pricer ---------- */
  class PtahPricer {
    constructor() {
      this.garmentKey = document.querySelector('[data-garment].is-active')?.dataset.garment || 'tee-box';
      this.printType  = 'none';
      this.printSize  = 'A4';
      this.placement  = 'left-chest';
      this.qty        = 1;
      this._bindPrint();
      this._bindQty();
      this.render();
    }
    setGarment(key) { this.garmentKey = key; this.render(); }
    // Selected color's retail price — colors now carry their own price
    // (from Rostik's folders); PDF table / fixedPrice is the fallback.
    setColorPrice(retail) {
      this.colorTiers = retail ? tierFromRetail(retail) : null;
      this.render();
    }
    _garmentAt(t) {
      if (this.colorTiers) return this.colorTiers[t];
      const data = garmentData[this.garmentKey]; if (!data) return 0;
      return data.tableKey && GARMENT_TABLE[data.tableKey]
        ? GARMENT_TABLE[data.tableKey][t] : (data.fixedPrice || 0);
    }
    _compute() {
      const data = garmentData[this.garmentKey]; if (!data) return null;
      const t = tierIndex(this.qty);
      const g = this._garmentAt(t);
      let p = 0;
      if (this.printType !== 'none') {
        const sm = PRINT_TABLE[this.printType];
        if (sm && sm[this.printSize]) p = sm[this.printSize][t];
      }
      return { g, p, unit: g + p, total: (g + p) * this.qty, tier: t, data };
    }
    _scalePrices() {
      return [0,1,2,3,4].map(t => {
        const g = this._garmentAt(t);
        const sm = this.printType !== 'none' ? PRINT_TABLE[this.printType] : null;
        return g + ((sm && sm[this.printSize]) ? sm[this.printSize][t] : 0);
      });
    }
    render() {
      const c = this._compute(); if (!c) return;
      const TL = ['1–10','10–25','25–50','50–100','100+'];
      const set = (id, t) => { const el = document.getElementById(id); if (el) el.textContent = t; };
      const dsp = (id, v) => { const el = document.getElementById(id); if (el) el.style.display = v; };
      // Tier scale bar
      const sc = this._scalePrices();
      document.querySelectorAll('[data-tier-scale]').forEach(el => {
        const i = +el.dataset.tierScale;
        el.classList.toggle('is-active', i === c.tier);
        const pr = el.querySelector('.tier-scale__price'); if (pr) pr.textContent = '$' + fmtPrice(sc[i]);
      });
      // Pricing breakdown
      set('cz-pr-garment-label', (c.data.name || 'Garment') + ' · ' + TL[c.tier] + ' tier');
      set('cz-pr-garment-val',   '$' + fmtPrice(c.g) + ' × ' + this.qty);
      const hp = this.printType !== 'none';
      dsp('cz-pricing-print', hp ? '' : 'none');
      if (hp) {
        const tl = { dtf: 'DTF', vinyl: 'Vinyl', embroidery: 'Embroidery' }[this.printType];
        set('cz-pr-print-label', tl + ' ' + this.printSize + ' · ' + TL[c.tier] + ' tier');
        set('cz-pr-print-val',   '$' + fmtPrice(c.p) + ' × ' + this.qty);
      }
      set('cz-pr-unit',  '$' + fmtPrice(c.unit) + ' per unit');
      set('cz-pr-total', '$' + fmtPrice(c.total));
      // ATC / Quote toggle
      const ab = document.getElementById('cz-atc-btn');
      if (ab) {
        const iq = this.qty >= RETAIL_MAX_QTY;
        ab.dataset.mode = iq ? 'quote' : 'cart';
        if (iq) {
          ab.textContent = 'Request a quote в†’';
          ab.className = ab.className.replace('btn--primary', 'btn--secondary');
          dsp('cz-bulk-hint-wrap', 'none'); dsp('cz-quote-note', '');
        } else {
          ab.innerHTML = 'Add to cart · <span>$' + fmtPrice(c.total) + '</span>';
          ab.className = ab.className.replace('btn--secondary', 'btn--primary');
          dsp('cz-bulk-hint-wrap', ''); dsp('cz-quote-note', 'none');
        }
      }
      // Sticky price sync
      document.querySelectorAll('[data-product-price]').forEach(el => {
        if (el.id !== 'cz-pr-total') el.textContent = '$' + c.total;
      });
      // Embroidery minimum notice (button stays enabled; notice warns below)
      dsp('embroidery-notice', (this.printType === 'embroidery' && this.qty < 7) ? '' : 'none');
    }
    _bindQty() {
      const inp = document.querySelector('[data-qty-input]'); if (!inp) return;
      const upd = () => { this.qty = Math.max(1, parseInt(inp.value, 10) || 1); this.render(); };
      inp.addEventListener('input', upd); inp.addEventListener('change', upd);
      // Tier bar buttons: clicking a range jumps qty to that tier's minimum
      const tierMins = [1, 10, 25, 50, 100];
      document.querySelectorAll('[data-tier-scale]').forEach(el => {
        el.addEventListener('click', () => {
          const min = tierMins[+el.dataset.tierScale];
          if (!min) return;
          inp.value = min;
          this.qty = min;
          this.render();
        });
      });
    }
    _bindPrint() {
      document.querySelectorAll('[data-print-type]').forEach(btn => {
        btn.addEventListener('click', () => {
          document.querySelectorAll('[data-print-type]').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          this.printType = btn.dataset.printType;
          this._updatePrintUI();
          this.render();
          if (window.dataLayer) window.dataLayer.push({ event: 'change_print_type', print_type: this.printType });
        });
      });
      document.addEventListener('click', e => {
        const btn = e.target.closest('[data-print-size]'); if (!btn) return;
        document.querySelectorAll('[data-print-size]').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        this.printSize = btn.dataset.printSize;
        const sv = document.getElementById('print-size-val'); if (sv) sv.textContent = this.printSize;
        this.render();
      });
      document.querySelectorAll('[data-placement]').forEach(btn => {
        btn.addEventListener('click', () => {
          document.querySelectorAll('[data-placement]').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          this.placement = btn.dataset.placement;
          const pv = document.getElementById('print-placement-val'); if (pv) pv.textContent = btn.textContent.trim();
        });
      });
    }
    _updatePrintUI() {
      const wrap = document.getElementById('print-size-wrap');
      const plw  = document.getElementById('print-placement-wrap');
      const dtfS = document.getElementById('print-size-dtf');
      const othS = document.getElementById('print-size-other');
      const gTech = document.getElementById('print-guide-techniques');
      const gEmb  = document.getElementById('print-guide-embroidery');
      const gSz   = document.getElementById('print-guide-sizes');
      const has  = this.printType !== 'none';
      if (wrap) wrap.style.display = has ? '' : 'none';
      if (plw)  plw.style.display  = has ? '' : 'none';
      const isDTF = this.printType === 'dtf';
      const isVinyl = this.printType === 'vinyl';
      const isEmb = this.printType === 'embroidery';
      if (gTech) gTech.style.display = (isDTF || isVinyl) ? '' : 'none';
      if (gEmb)  gEmb.style.display  = isEmb ? '' : 'none';
      if (gSz)   gSz.style.display   = has ? '' : 'none';
      if (has) {
        if (dtfS) dtfS.style.display = (isDTF || isVinyl) ? '' : 'none';
        if (othS) othS.style.display = isEmb ? '' : 'none';
        this.printSize = isEmb ? 'small' : 'A4';
        document.querySelectorAll('[data-print-size]').forEach(b => b.classList.toggle('is-active', b.dataset.printSize === this.printSize));
        const sv = document.getElementById('print-size-val'); if (sv) sv.textContent = this.printSize;
      }
    }
  }
  /* ---------- Garment switcher (customize page) ---------- */
  function bindGarmentSwitcher() {
    const cards = $$('[data-garment]');
    if (!cards.length) return;

    const garmentColors = {
      // Catalog rebuilt 2026-07-02 from Rostik's priced folders.
      // price  = retail for THAT color (folder/file names are the source);
      // note   = size limits parsed from file names;
      // back   = rear-view photo (enables the Front/Back toggle + 2D back print).
      // Tier prices derive from `price` via TIER_MULT in the pricer.
      'tee-box': [
        { slug: 'limo-black',       label: 'Limo Black',       hex: '#1e1e1e', price: 20, img: _cdnBase + 'img/products/tee-box-75oz/limo-black.webp' },
        { slug: 'pfd-white',        label: 'PFD White',        hex: '#f3f3f3', price: 20, img: _cdnBase + 'img/products/tee-box-75oz/pfd-white.webp' },
        { slug: 'wheat',            label: 'Wheat',            hex: '#9b7c55', price: 20, img: _cdnBase + 'img/products/tee-box-75oz/wheat.webp' },
        { slug: 'string-tan',       label: 'String Tan',       hex: '#cbc5ba', price: 20, note: 'Up to 2XL', img: _cdnBase + 'img/products/tee-box-75oz/string-tan.webp' },
        { slug: 'chocolate',        label: 'Chocolate',        hex: '#684a3f', price: 20, note: 'Up to 3XL', img: _cdnBase + 'img/products/tee-box-75oz/chocolate.webp' },
        { slug: 'forest-green',     label: 'Forest Green',     hex: '#2f3f32', price: 22, img: _cdnBase + 'img/products/tee-box-75oz/forest-green.webp' },
        { slug: 'navy',             label: 'Navy',             hex: '#494960', price: 22, img: _cdnBase + 'img/products/tee-box-75oz/navy.webp' },
        { slug: 'pigment-rust',     label: 'Pigment Rust',     hex: '#ba613b', price: 28, note: 'Up to 2XL', img: _cdnBase + 'img/products/tee-box-75oz/pigment-rust.webp' },
        { slug: 'vintage-gray',     label: 'Vintage Gray',     hex: '#babcbd', price: 28, img: _cdnBase + 'img/products/tee-box-75oz/vintage-gray.webp' },
        { slug: 'vintage-mahogany', label: 'Vintage Mahogany', hex: '#603f43', price: 28, img: _cdnBase + 'img/products/tee-box-75oz/vintage-mahogany.webp' },
        { slug: 'leopard',          label: 'Leopard',          hex: '#7e6251', price: 35, img: _cdnBase + 'img/products/tee-box-75oz/leopard.webp', back: _cdnBase + 'img/products/tee-box-75oz/leopard-back.webp' },
      ],
      'tee-drop': [
        { slug: 'black',   label: 'Black',   hex: '#1d1b21', price: 20, img: _cdnBase + 'img/products/tee-drop-70oz/black.webp' },
        { slug: 'grey',    label: 'Grey',    hex: '#d0ccc6', price: 20, img: _cdnBase + 'img/products/tee-drop-70oz/grey.webp' },
        { slug: 'white',   label: 'White',   hex: '#ececec', price: 20, img: _cdnBase + 'img/products/tee-drop-70oz/white.webp' },
        { slug: 'vintage', label: 'Vintage', hex: '#464646', price: 25, img: _cdnBase + 'img/products/tee-drop-70oz/vintage.webp' },
        { slug: 'beige',   label: 'Beige',   hex: '#887358', price: 25, img: _cdnBase + 'img/products/tee-drop-70oz/beige.webp' },
      ],
      'tee-daily': [
        { slug: 'limo-black', label: 'Limo Black', hex: '#1c1c1c', price: 18, img: _cdnBase + 'img/products/tee-daily-65oz/limo-black.webp' },
        { slug: 'grey',       label: 'Grey',       hex: '#c9cac4', price: 18, img: _cdnBase + 'img/products/tee-daily-65oz/grey.webp' },
        { slug: 'navy',       label: 'Navy',       hex: '#5c5b6e', price: 18, img: _cdnBase + 'img/products/tee-daily-65oz/navy.webp' },
        { slug: 'white',      label: 'White',      hex: '#dbdbd9', price: 18, img: _cdnBase + 'img/products/tee-daily-65oz/white.webp' },
        { slug: 'brown',      label: 'Brown',      hex: '#8c6e56', price: 25, img: _cdnBase + 'img/products/tee-daily-65oz/brown.webp' },
        { slug: 'green',      label: 'Green',      hex: '#949f86', price: 25, img: _cdnBase + 'img/products/tee-daily-65oz/green.webp' },
        { slug: 'vintage',    label: 'Vintage',    hex: '#3e4147', price: 25, img: _cdnBase + 'img/products/tee-daily-65oz/vintage.webp' },
      ],
      'tee-tour': [
        { slug: 'black', label: 'Black', hex: '#1f1f1f', price: 32, img: _cdnBase + 'img/products/tee-tour-60oz/tour-black.jpg' },
        { slug: 'grey',  label: 'Grey',  hex: '#92989c', price: 32, img: _cdnBase + 'img/products/tee-tour-60oz/tour-grey.jpg' },
        { slug: 'blue',  label: 'Blue',  hex: '#132948', price: 32, img: _cdnBase + 'img/products/tee-tour-60oz/tour-blue.jpg' },
      ],
      'tee-wash': [
        { slug: 'black',      label: 'Washed Black', hex: '#3d3c41', price: 26, img: _cdnBase + 'img/products/tee-wash/black.jpg' },
        { slug: 'grey',       label: 'Washed Grey',  hex: '#b0a6af', price: 26, img: _cdnBase + 'img/products/tee-wash/grey.jpg' },
        { slug: 'dark-grey',  label: 'Dark Grey',    hex: '#8f8e93', price: 26, img: _cdnBase + 'img/products/tee-wash/dark-grey.jpg' },
        { slug: 'blue',       label: 'Washed Blue',  hex: '#3e435a', price: 26, img: _cdnBase + 'img/products/tee-wash/blue.jpg' },
        { slug: 'green-wash', label: 'Washed Green', hex: '#706f62', price: 26, img: _cdnBase + 'img/products/tee-wash/green-wash.jpg' },
      ],
      'ls-box': [
        { slug: 'blanc-white',   label: 'Blanc White',       hex: '#d0d8dc', price: 32, img: _cdnBase + 'img/products/ls-box-75oz/blanc-white.webp' },
        { slug: 'limo-black',    label: 'Limo Black',        hex: '#242834', price: 32, note: 'S–3XL $32 · 4XL $40', img: _cdnBase + 'img/products/ls-box-75oz/limo-black.webp' },
        { slug: 'chocolate',     label: 'Chocolate',         hex: '#776c60', price: 32, note: 'Up to 2XL', img: _cdnBase + 'img/products/ls-box-75oz/chocolate.webp' },
        { slug: 'vintage-black', label: 'Vintage Black',     hex: '#484c4e', price: 42, img: _cdnBase + 'img/products/ls-box-75oz/vintage-black.webp' },
        { slug: 'dirty-white',   label: 'Dirty White',       hex: '#dbd6d3', price: 45, img: _cdnBase + 'img/products/ls-box-75oz/dirty-white.webp' },
        { slug: 'blue',          label: 'Blue',              hex: '#aec7e1', price: 47, img: _cdnBase + 'img/products/ls-box-75oz/blue.webp' },
        { slug: 'oil-charcoal',  label: 'Oil Wash Charcoal', hex: '#a19ba1', price: 47, img: _cdnBase + 'img/products/ls-box-75oz/oil-charcoal.webp' },
        { slug: 'pink',          label: 'Pink',              hex: '#d4aeb1', price: 47, img: _cdnBase + 'img/products/ls-box-75oz/pink.webp' },
      ],
      'ls-heavy': [],
      'sweat-15': [],
      'sweat-13': [],
      'hoodie-14': [
        { slug: 'black',       label: 'Black',       hex: '#373835', price: 60, img: _cdnBase + 'img/products/hoodie-14oz/black.webp' },
        { slug: 'beige',       label: 'Beige',       hex: '#b09e98', price: 65, img: _cdnBase + 'img/products/hoodie-14oz/beige.webp' },
        { slug: 'orange',      label: 'Orange',      hex: '#e16500', price: 70, img: _cdnBase + 'img/products/hoodie-14oz/orange.webp' },
        { slug: 'sky-blue',    label: 'Sky Blue',    hex: '#018ab0', price: 70, img: _cdnBase + 'img/products/hoodie-14oz/sky-blue.webp' },
        { slug: 'worn-blue',   label: 'Worn Blue',   hex: '#4674c6', price: 70, img: _cdnBase + 'img/products/hoodie-14oz/worn-blue.webp' },
        { slug: 'light-brown', label: 'Light Brown', hex: '#826d5d', price: 70, img: _cdnBase + 'img/products/hoodie-14oz/light-brown.webp' },
        { slug: 'purple',      label: 'Purple',      hex: '#59536c', price: 70, img: _cdnBase + 'img/products/hoodie-14oz/purple.webp' },
      ],
      'hoodie-15':     [],
      'hoodie-casual': [],
      'zip-11': [
        { slug: 'black',      label: 'Black',      hex: '#29282d', price: 60, img: _cdnBase + 'img/products/zip-hoodie-11oz/black.webp' },
        { slug: 'white',      label: 'White',      hex: '#dfded9', price: 60, img: _cdnBase + 'img/products/zip-hoodie-11oz/white.webp' },
        { slug: 'worn-black', label: 'Worn Black', hex: '#3e3e3e', price: 70, img: _cdnBase + 'img/products/zip-hoodie-11oz/worn-black.webp' },
      ],
      'zip-15':   [],
      'cap-mesh': [
        { slug: 'black-mesh', label: 'Black / Mesh', hex: '#1c1c1c', price: 20, img: _cdnBase + 'img/products/cap-mesh/front.jpg', back: _cdnBase + 'img/products/cap-mesh/back.jpg' },
      ],
      'cap-ptah': [
        { slug: 'raven',    label: 'Raven',    hex: '#1b1b1b', price: 10, img: _cdnBase + 'img/products/cap-ptah/raven-front.jpg',    back: _cdnBase + 'img/products/cap-ptah/raven.jpg' },
        { slug: 'admiral',  label: 'Admiral',  hex: '#152032', price: 10, img: _cdnBase + 'img/products/cap-ptah/admiral-front.jpg',  back: _cdnBase + 'img/products/cap-ptah/admiral.jpg' },
        { slug: 'cardinal', label: 'Cardinal', hex: '#911026', price: 10, img: _cdnBase + 'img/products/cap-ptah/cardinal-front.jpg', back: _cdnBase + 'img/products/cap-ptah/cardinal.jpg' },
        { slug: 'graphite', label: 'Graphite', hex: '#403a3a', price: 10, img: _cdnBase + 'img/products/cap-ptah/graphite-front.jpg', back: _cdnBase + 'img/products/cap-ptah/graphite.jpg' },
        { slug: 'silver',   label: 'Silver',   hex: '#b6b3ac', price: 10, img: _cdnBase + 'img/products/cap-ptah/silver-front.jpg',   back: _cdnBase + 'img/products/cap-ptah/silver.jpg' },
      ],
      'polo': [
        { slug: 'black',            label: 'Black',            hex: '#17181a', price: 30, img: _cdnBase + 'img/products/polo-30/black.jpg',            back: _cdnBase + 'img/products/polo-30/black-back.jpg' },
        { slug: 'charcoal-heather', label: 'Charcoal Heather', hex: '#4a4a4c', price: 30, img: _cdnBase + 'img/products/polo-30/charcoal-heather.jpg', back: _cdnBase + 'img/products/polo-30/charcoal-heather-back.jpg' },
        { slug: 'sterling-grey',    label: 'Sterling Grey',    hex: '#8e9094', price: 30, img: _cdnBase + 'img/products/polo-30/sterling-grey.jpg',    back: _cdnBase + 'img/products/polo-30/sterling-grey-back.jpg' },
        { slug: 'oxford-heather',   label: 'Oxford Heather',   hex: '#b8b8bc', price: 30, img: _cdnBase + 'img/products/polo-30/oxford-heather.jpg',   back: _cdnBase + 'img/products/polo-30/oxford-heather-back.jpg' },
        { slug: 'white',            label: 'White',            hex: '#f2f2f0', price: 30, img: _cdnBase + 'img/products/polo-30/white.jpg',            back: _cdnBase + 'img/products/polo-30/white-back.jpg' },
        { slug: 'navy',             label: 'Navy',             hex: '#232c44', price: 30, img: _cdnBase + 'img/products/polo-30/navy.jpg',             back: _cdnBase + 'img/products/polo-30/navy-back.jpg' },
        { slug: 'royal-blue',       label: 'Royal Blue',       hex: '#2a4a9c', price: 30, img: _cdnBase + 'img/products/polo-30/royal-blue.jpg',       back: _cdnBase + 'img/products/polo-30/royal-blue-back.jpg' },
        { slug: 'red',              label: 'Red',              hex: '#a02028', price: 30, img: _cdnBase + 'img/products/polo-30/red.jpg',              back: _cdnBase + 'img/products/polo-30/red-back.jpg' },
      ],
    };

    // Shared selection state: which garment/color/view is active. The main
    // gallery, the color row under the 2D canvas and the Front/Back toggles
    // all read and write it through applySelection().
    const czSel = { key: null, colorIdx: 0, view: 'front' };
    window._czSel = czSel;

    function czColor() {
      const colors = garmentColors[czSel.key] || [];
      return colors[czSel.colorIdx] || null;
    }
    function czUrl() {
      const c = czColor();
      if (!c) return null;
      return (czSel.view === 'back' && c.back) ? c.back : c.img;
    }
    // Push the current selection into the main photo + 2D canvas + toggles
    function applySelection() {
      const c = czColor();
      const url = czUrl();
      const mainImg = document.getElementById('cz-main-img');
      if (mainImg && url) { mainImg.src = url; mainImg.style.display = ''; }
      if (url) {
        document.dispatchEvent(new CustomEvent('ptah:garment-changed', { detail: { url: url, hex: c ? c.hex : '#1a1d1c' } }));
      }
      // Front/Back toggles (gallery + viz) — visible only when a back exists
      document.querySelectorAll('[data-view-toggle]').forEach(t => {
        const has = !!(c && c.back);
        t.hidden = !has;
        if (has) {
          t.querySelectorAll('[data-view]').forEach(b => {
            b.classList.toggle('is-active', b.dataset.view === czSel.view);
          });
        }
      });
      // viz mirror active dot
      document.querySelectorAll('[data-viz-colors-row] .viz-dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === czSel.colorIdx);
      });
      // per-color retail drives the tier prices
      if (window._ptahPricer) window._ptahPricer.setColorPrice(c && c.price ? c.price : null);
      // size-limit note from the catalog (e.g. "Up to 2XL") — element is
      // created on demand right under the color swatches
      let noteEl = document.querySelector('[data-color-note]');
      if (!noteEl) {
        const picker = document.querySelector('[data-variant-picker]');
        if (picker) {
          noteEl = document.createElement('div');
          noteEl.className = 'cz-color-note';
          noteEl.setAttribute('data-color-note', '');
          picker.insertAdjacentElement('afterend', noteEl);
        }
      }
      if (noteEl) {
        const has = !!(c && c.note);
        noteEl.hidden = !has;
        noteEl.textContent = has ? '⚠ ' + c.note : '';
      }
    }
    window._czApplySelection = applySelection;

    function selectColor(i) {
      czSel.colorIdx = i;
      const c = czColor();
      if (!c) return;
      if (!c.back) czSel.view = 'front';
      const colorVal = document.getElementById('cz-color-val');
      if (colorVal) colorVal.textContent = c.label;
      // keep the configurator radio in sync (without re-firing loops)
      const radios = document.querySelectorAll('[data-variant-picker] input[name="color"]');
      if (radios[i] && !radios[i].checked) radios[i].checked = true;
      applySelection();
    }
    window._czSelectColor = selectColor;

    // Front/Back buttons live in [data-view-toggle] containers
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-view-toggle] [data-view]');
      if (!btn) return;
      czSel.view = btn.dataset.view;
      applySelection();
    });

    function renderSwatches(garmentKey) {
      const container = document.querySelector('[data-variant-picker]');
      if (!container) return;
      const colorVal = document.getElementById('cz-color-val');
      const colors = garmentColors[garmentKey] || [];
      czSel.key = garmentKey;
      czSel.colorIdx = 0;
      czSel.view = 'front';

      const vizWrap = document.querySelector('[data-viz-colors]');
      const vizRow = document.querySelector('[data-viz-colors-row]');

      if (!colors.length) {
        container.innerHTML = '<span style="color:var(--ink-3);font-size:var(--t-xs);font-family:var(--font-mono)">Colors available on request</span>';
        if (colorVal) colorVal.textContent = '—';
        if (vizWrap) vizWrap.hidden = true;
        document.querySelectorAll('[data-view-toggle]').forEach(t => { t.hidden = true; });
        return;
      }

      container.innerHTML = '';
      colors.forEach((c, i) => {
        const id = 'color-' + garmentKey + '-' + i;
        const inp = document.createElement('input');
        inp.type = 'radio';
        inp.id = id;
        inp.name = 'color';
        inp.value = c.label;
        inp.setAttribute('data-opt', '');
        inp.dataset.colorImg = c.img;
        inp.dataset.hex = c.hex;
        inp.dataset.colorIdx = i;
        inp.className = 'sr-only';
        if (i === 0) inp.checked = true;
        const lbl = document.createElement('label');
        lbl.htmlFor = id;
        lbl.className = 'swatch';
        lbl.style.background = c.hex;
        lbl.title = c.label;
        container.appendChild(inp);
        container.appendChild(lbl);
      });

      // Mirror the palette under the 2D visualizer
      if (vizRow) {
        vizRow.innerHTML = '';
        colors.forEach((c, i) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.className = 'viz-dot' + (i === 0 ? ' is-active' : '');
          d.style.background = c.hex;
          d.title = c.label;
          d.setAttribute('aria-label', c.label);
          d.addEventListener('click', () => selectColor(i));
          vizRow.appendChild(d);
        });
        if (vizWrap) vizWrap.hidden = false;
      }

      if (colorVal) colorVal.textContent = colors[0].label;
      applySelection();
    }

    cards.forEach(card => {
      card.addEventListener('click', () => {
        const key = card.dataset.garment;
        const data = garmentData[key];
        if (!data) return;

        // Update active state
        cards.forEach(c => c.classList.remove('is-active'));
        card.classList.add('is-active');

        // Update product name, specs, sticky atc title
        const nameEl = $('#cz-product-name');
        if (nameEl) nameEl.textContent = data.name;
        const specsEl = $('#cz-product-specs');
        if (specsEl) specsEl.textContent = data.specs;
        const stickyTitle = $('#cz-sticky-title');
        if (stickyTitle) stickyTitle.textContent = data.name;

        // Re-render color swatches for this garment
        renderSwatches(key);

        // Update main photo to first color (or garment default)
        const mainImg = document.getElementById('cz-main-img');
        const colors = garmentColors[key] || [];
        const firstColorImg = colors.length ? colors[0].img : card.dataset.garmentImg;
        if (mainImg) {
          if (firstColorImg) {
            mainImg.src = firstColorImg;
            mainImg.alt = data.name;
            mainImg.style.display = '';
          }
          // No image for this garment — keep previous image visible rather than hiding
        }

        // Update form title for cart
        const form = $('[data-product-form]');
        if (form) form.dataset.productTitle = data.name;

        // Notify 2D visualizer
        if (firstColorImg) {
          const firstHex = colors.length ? colors[0].hex : '#1a1d1c';
          document.dispatchEvent(new CustomEvent('ptah:garment-changed', { detail: { url: firstColorImg, hex: firstHex } }));
        }

        // Notify pricer
        if (window._ptahPricer) window._ptahPricer.setGarment(key);
      });
    });

    // Render swatches for the initially active garment and seed visualizer
    const activeCard = document.querySelector('[data-garment].is-active');
    if (activeCard) {
      const key = activeCard.dataset.garment;
      renderSwatches(key);
      const initColors = garmentColors[key] || [];
      const initUrl = initColors.length ? initColors[0].img : activeCard.dataset.garmentImg;
      if (initUrl) {
        const initHex = initColors.length ? initColors[0].hex : '#1a1d1c';
        document.dispatchEvent(new CustomEvent('ptah:garment-changed', { detail: { url: initUrl, hex: initHex } }));
      }
    }
  }

  /* ---------- View picker (front/back/sleeve/detail thumbs) ---------- */
  function bindViewPicker() {
    const thumbs = $$('.cz-thumb[data-view]');
    if (!thumbs.length) return;
    const views = {
      front: 'Front view',
      back: 'Back view',
      sleeve: 'Sleeve detail',
      detail: 'Fabric texture close-up'
    };
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const view = thumb.dataset.view;
        const mainDesc = $('#cz-main-desc');
        if (mainDesc) {
          const color = $('#cz-color-val')?.textContent || 'Washed Black';
          const size = $('#cz-size-val')?.textContent || 'L';
          const qty = $('[data-qty-input]')?.value || '1';
          mainDesc.textContent = 'Selected: ' + color + ' · Size ' + size + ' · ' + qty + ' pc' + (qty > 1 ? 's' : '') + ' · ' + views[view];
        }
      });
    });
  }

  /* ---------- Color/size live label updates ---------- */
  function bindLiveLabels() {
    const sizeInputs = $$('input[name="size"]');
    const qtyInput = $('[data-qty-input]');
    const colorVal = $('#cz-color-val');
    const sizeVal = $('#cz-size-val');
    const mainDesc = $('#cz-main-desc');

    function updateMainDesc() {
      if (!mainDesc) return;
      const color = colorVal?.textContent || 'Washed Black';
      const size = sizeVal?.textContent || 'L';
      const qty = qtyInput?.value || '1';
      mainDesc.textContent = 'Selected: ' + color + ' · Size ' + size + ' · ' + qty + ' pc' + (qty > 1 ? 's' : '');
    }

    // Event delegation handles both static and dynamically re-rendered swatches
    const swatchWrapper = document.querySelector('[data-variant-picker]');
    if (swatchWrapper) {
      swatchWrapper.addEventListener('change', (e) => {
        if (e.target.name !== 'color') return;
        if (colorVal) colorVal.textContent = e.target.value;
        // Route through the shared selection state (keeps view + viz row in
        // sync); falls back to the legacy path for static swatch markup.
        if (window._czSelectColor && e.target.dataset.colorIdx !== undefined) {
          window._czSelectColor(parseInt(e.target.dataset.colorIdx, 10));
        } else {
          const img = e.target.dataset.colorImg;
          if (img) {
            const mainImg = document.getElementById('cz-main-img');
            if (mainImg) { mainImg.src = img; mainImg.style.display = ''; }
            const hx = e.target.dataset.hex || '#1a1d1c';
            document.dispatchEvent(new CustomEvent('ptah:garment-changed',{detail:{url:img,hex:hx}}));
          }
        }
        updateMainDesc();
      });
    }

    sizeInputs.forEach(input => {
      input.addEventListener('change', () => {
        if (input.checked && sizeVal) sizeVal.textContent = input.value;
        updateMainDesc();
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', updateMainDesc);
      qtyInput.addEventListener('change', updateMainDesc);
    }
  }

  /* ---------- Sticky ATC ---------- */
  function bindStickyATC() {
    const sticky = $('.sticky-atc');
    const trigger = $('[data-atc-trigger]');
    if (!sticky || !trigger) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) sticky.classList.remove('is-visible');
        else if (e.boundingClientRect.top < 0) sticky.classList.add('is-visible');
      });
    });
    observer.observe(trigger);

    const btn = $('[data-sticky-atc]');
    if (btn) btn.addEventListener('click', () => {
      const main = $('[data-main-atc]');
      if (main) main.click();
    });
  }

  /* ---------- Product form (ATC) ---------- */
  function bindProductForm() {
    document.querySelectorAll('[data-product-form]').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const ab = document.getElementById('cz-atc-btn');
        if (ab?.dataset.mode === 'quote') { redirectToBulk(); return; }

        const pricer = window._ptahPricer;
        const c = pricer ? pricer._compute() : null;
        if (!c) return;

        const color = document.getElementById('cz-color-val')?.textContent || '';
        const size  = document.getElementById('cz-size-val')?.textContent  || 'L';

        if (window.PTAH_CUSTOM_VARIANT_ID) {
          // Shopify mode: one $1-product × total-dollars
          const props = {
            'Garment': c.data.name, 'Color': color, 'Size (garment)': size,
            'Print': pricer.printType === 'none' ? 'None' : pricer.printType.toUpperCase() + ' · ' + pricer.printSize,
            'Placement': pricer.printType !== 'none' ? pricer.placement : '—',
            'Qty (pcs)': String(pricer.qty),
            'Per unit ($)': String(c.unit),
            'Tier': ['1–10','10–25','25–50','50–100','100+'][c.tier]
          };
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: window.PTAH_CUSTOM_VARIANT_ID, quantity: c.total, properties: props })
          })
          .then(r => r.json())
          .then(() => {
            if (window.dataLayer) window.dataLayer.push({ event: 'add_to_cart', value: c.total, currency: 'USD' });
            window.location.href = '/cart';
          })
          .catch(() => toast('Could not add to cart — try again'));
        } else {
          // Static / preview mode: localStorage cart
          const mainImg = document.getElementById('cz-main-img');
          const printLabel = pricer.printType !== 'none'
            ? pricer.printType.toUpperCase() + ' ' + pricer.printSize + ' · ' + pricer.placement
            : '';
          addToCart({
            title:   'PTAH Custom · ' + c.data.name,
            image:   mainImg?.src || '',
            variant: [color, size].filter(Boolean).join(' / '),
            method:  printLabel,
            price:   c.total * 100, // display price in cents (stored as dollar Г— 100)
            qty:     1
          });
          toast('Added to cart');
          const cd = document.getElementById('cart-drawer');
          if (cd) {
            cd.classList.add('is-open');
            const ov = document.querySelector('.drawer-overlay[data-target="cart-drawer"]');
            if (ov) ov.classList.add('is-open');
            document.body.classList.add('no-scroll');
          }
          if (window.dataLayer) window.dataLayer.push({ event: 'add_to_cart', value: c.total });
        }
      });
    });
  }

  function redirectToBulk() {
    const pr = window._ptahPricer;
    const c  = pr?._compute();
    const color = document.getElementById('cz-color-val')?.textContent || '';
    const size  = document.getElementById('cz-size-val')?.textContent  || 'L';
    const p = new URLSearchParams({
      g: pr?.garmentKey || '', col: color, sz: size,
      pt: pr?.printType || 'none', ps: pr?.printSize || '',
      pl: pr?.placement || '', qty: pr?.qty || 1, est: c?.total || 0
    });
    const base = window.SHOPIFY_CDN ? '/pages/bulk-orders' : 'bulk.html';
    window.location.href = base + '?' + p.toString();
  }
  /* ---------- Motion: scroll reveal ---------- */
  function initReveal() {
    const els = $$('[data-reveal]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('is-revealed'));
      return;
    }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const d = parseInt(e.target.dataset.revealDelay || '0', 10);
          setTimeout(() => e.target.classList.add('is-revealed'), d);
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    els.forEach(el => obs.observe(el));
  }

  /* ---------- Motion: stagger reveal (sibling-aware) ---------- */
  function initRevealStagger() {
    const els = $$('[data-reveal-stagger]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('is-revealed'));
      return;
    }
    const obs = new IntersectionObserver(entries => {
      const visible = entries.filter(e => e.isIntersecting);
      visible.forEach((e) => {
        const parent = e.target.parentElement;
        const siblings = parent ? $$(':scope > [data-reveal-stagger]', parent) : [e.target];
        const idx = siblings.indexOf(e.target);
        const delay = Math.max(0, idx) * 130;
        setTimeout(() => e.target.classList.add('is-revealed'), delay);
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(el => obs.observe(el));
  }

  function initStagger() {
    const groups = $$('[data-stagger]');
    if (!groups.length) return;
    if (reduceMotion) {
      groups.forEach(g => $$(':scope > *', g).forEach(c => c.classList.add('is-revealed')));
      return;
    }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const step = parseInt(e.target.dataset.stagger || '80', 10);
          $$(':scope > *', e.target).forEach((c, i) => {
            setTimeout(() => c.classList.add('is-revealed'), i * step);
          });
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });
    groups.forEach(g => {
      $$(':scope > *', g).forEach(c => c.classList.add('stagger-item'));
      obs.observe(g);
    });
  }

  /* ---------- Parallax ---------- */
  function initParallax() {
    const els = $$('[data-parallax]');
    if (!els.length || reduceMotion) return;
    let ticking = false;
    function update() {
      const vh = window.innerHeight;
      els.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const speed = parseFloat(el.dataset.parallax) || 0.15;
        const center = r.top + r.height / 2;
        const progress = (center - vh / 2) / (vh / 2);
        el.style.transform = `translate3d(0, ${progress * speed * 100}px, 0)`;
      });
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Count-up ---------- */
  function initCounters() {
    const els = $$('[data-count-to]');
    if (!els.length) return;
    if (reduceMotion) {
      els.forEach(el => {
        const t = parseFloat(el.dataset.countTo);
        el.textContent = fmt(t, el.dataset.countSuffix, el.dataset.countPrefix);
      });
      return;
    }
    const fmt = (n, suf, pre) => (pre || '') + Math.round(n).toLocaleString('en-US') + (suf || '');
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const target = parseFloat(e.target.dataset.countTo);
          const suf = e.target.dataset.countSuffix || '';
          const pre = e.target.dataset.countPrefix || '';
          const dur = 1600;
          const start = performance.now();
          const tick = (now) => {
            const t = Math.min(1, (now - start) / dur);
            const eased = t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
            e.target.textContent = fmt(target * eased, suf, pre);
            if (t < 1) requestAnimationFrame(tick);
            else e.target.textContent = fmt(target, suf, pre);
          };
          requestAnimationFrame(tick);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(el => obs.observe(el));
  }

  /* ---------- Marquee ---------- */
  function initMarquee() {
    $$('[data-marquee]').forEach(track => {
      track.innerHTML = track.innerHTML + track.innerHTML;
      if (reduceMotion) track.style.animationPlayState = 'paused';
    });
  }

  /* ---------- Header scroll ---------- */
  function initHeaderScroll() {
    const h = $('.header');
    if (!h) return;
    const upd = () => h.classList.toggle('is-scrolled', window.scrollY > 20);
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* ---------- Bulk calculator ---------- */
  const BULK_PRICING = {
    // Per-garment base prices (cents) by garment type
    // Tiers = anchor model's retail × TIER_MULT (Box $20 / LS $32 /
    // Hoodie & Zip $60 / Polo $30); sweat keeps its PDF row (no new data).
    garments: {
      'tee':        { name: 'Heavyweight Tee',       tiers: [[1, 2000], [10, 1900], [25, 1800], [50, 1700], [100, 1600]] },
      'longsleeve': { name: 'Long Sleeve Tee',       tiers: [[1, 3200], [10, 3000], [25, 2850], [50, 2700], [100, 2550]] },
      'sweat':      { name: 'Crew Sweatshirt',       tiers: [[1, 5600], [10, 5300], [25, 5000], [50, 4800], [100, 4500]] },
      'hoodie':     { name: 'Heavy Hoodie',          tiers: [[1, 6000], [10, 5650], [25, 5350], [50, 5050], [100, 4750]] },
      'zip':        { name: 'Heavy Zip-Hoodie',      tiers: [[1, 6000], [10, 5650], [25, 5350], [50, 5050], [100, 4750]] },
      'polo':       { name: 'Classic Pique Polo',    tiers: [[1, 3000], [10, 2800], [25, 2650], [50, 2500], [100, 2350]] }
    },
    // Print-method surcharges by size (cents) at each tier
    methods: {
      'dtf':        { name: 'DTF Print',  sizes: {
        'a6': [[1, 900],  [10, 800],  [25, 700],  [50, 600],  [100, 500]],
        'a5': [[1, 1400], [10, 1200], [25, 1100], [50, 1000], [100, 800]],
        'a4': [[1, 2000], [10, 1700], [25, 1500], [50, 1200], [100, 1000]],
        'a3': [[1, 2400], [10, 2000], [25, 1800], [50, 1600], [100, 1400]]
      }},
      'embroidery': { name: 'Embroidery', sizes: {
        'a6': [[1, 1200], [10, 1000], [25, 900],  [50, 800],  [100, 700]],
        'a5': [[1, 2000], [10, 1800], [25, 1600], [50, 1400], [100, 1200]],
        'a4': [[1, 3000], [10, 2700], [25, 2400], [50, 2100], [100, 1800]],
        'a3': [[1, 5500], [10, 4800], [25, 4200], [50, 3600], [100, 3200]]
      }},
      'vinyl':      { name: 'Vinyl Print', sizes: {
        'a6': [[1, 800],  [10, 700],  [25, 600],  [50, 500],  [100, 400]],
        'a5': [[1, 1300], [10, 1100], [25, 1000], [50, 800],  [100, 700]],
        'a4': [[1, 2000], [10, 1800], [25, 1600], [50, 1400], [100, 1200]],
        'a3': [[1, 3200], [10, 2800], [25, 2400], [50, 2000], [100, 1800]]
      }}
    }
  };

  function pickTier(tiers, qty) {
    let chosen = tiers[0];
    tiers.forEach(t => { if (qty >= t[0]) chosen = t; });
    return chosen[1];
  }

  // Concrete models per garment type — photos from the customize catalog.
  // Pricing stays per TYPE (quote is manual anyway); the chosen model is
  // carried into the summary + quote message.
  // _cdnBase: на Shopify — CDN темы, на статике — 'assets/'.
  // Голые 'assets/…' пути на Shopify превращались в 404 (чипы без картинок).
  const BULK_MODELS = {
    tee: [
      { name: 'Oversized Box 7.5oz', img: _cdnBase + 'img/products/tee-box-75oz/limo-black.webp' },
      { name: 'Drop Crop 7.0oz',     img: _cdnBase + 'img/products/tee-drop-70oz/black.webp' },
      { name: 'Daily 6.5oz',         img: _cdnBase + 'img/products/tee-daily-65oz/limo-black.webp' },
      { name: 'Tour 6.0oz',          img: _cdnBase + 'img/products/tee-tour-60oz/tour-black.jpg' },
      { name: 'Casual Wash',         img: _cdnBase + 'img/products/tee-wash/black.jpg' }
    ],
    zip: [
      { name: 'Zip Hoodie 11oz',     img: _cdnBase + 'img/products/zip-hoodie-11oz/black.webp' },
      { name: 'Heavy Zip 15oz',      img: _cdnBase + 'img/products/zip-hoodie-11oz/worn-black.webp' }
    ]
  };

  function initBulkCalc() {
    const calc = $('[data-calc]');
    if (!calc) return;

    const state = {
      garment: 'hoodie',
      model: '',
      qty: 25,
      method: 'dtf',
      size: 'a4',
      rush: false
    };

    // Model chips for the selected garment type (photo + name)
    function buildModels() {
      const wrap = $('[data-calc-models]');
      const row = $('[data-calc-models-row]');
      if (!wrap || !row) return;
      const models = BULK_MODELS[state.garment];
      if (!models || models.length < 2) {
        wrap.hidden = true;
        state.model = '';
        return;
      }
      wrap.hidden = false;
      // Large photo cards. First tap SELECTS the model; tapping the already
      // selected card (or the magnifier) opens the full-size photo.
      row.innerHTML = models.map((m, i) =>
        '<button type="button" class="calc__model calc__model--card' + (i === 0 ? ' is-active' : '') + '" data-calc-model="' + m.name + '">' +
          '<span class="calc__model-media">' +
            '<img src="' + m.img + '" alt="' + m.name + '">' +
            '<span class="calc__model-zoom" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="17" height="17"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3M11 8v6M8 11h6" stroke-linecap="round"/></svg></span>' +
          '</span>' +
          '<span class="calc__model-name">' + m.name + '</span>' +
        '</button>'
      ).join('');
      state.model = models[0].name;
      function openModelPhoto(src) {
        // same overlay the global [data-lightbox] handler builds
        const ov = document.createElement('div');
        ov.className = 'lightbox-overlay';
        const full = document.createElement('img');
        full.src = src;
        ov.appendChild(full);
        function close(){ ov.remove(); document.removeEventListener('keydown', onKey); }
        function onKey(ev){ if (ev.key === 'Escape') close(); }
        ov.addEventListener('click', close);
        document.addEventListener('keydown', onKey);
        document.body.appendChild(ov);
      }
      row.querySelectorAll('[data-calc-model]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const wasActive = btn.classList.contains('is-active');
          const zoomHit = !!e.target.closest('.calc__model-zoom');
          row.querySelectorAll('[data-calc-model]').forEach(x => x.classList.remove('is-active'));
          btn.classList.add('is-active');
          state.model = btn.dataset.calcModel;
          compute();
          if (wasActive || zoomHit) openModelPhoto(btn.querySelector('img').src);
        });
      });
    }

    function read() {
      const g = $('[data-calc-garment].is-active');
      const m = $('[data-calc-method].is-active');
      const s = $('[data-calc-size].is-active');
      const r = $('[data-calc-rush]');
      if (g) state.garment = g.dataset.calcGarment;
      if (m) state.method = m.dataset.calcMethod;
      if (s) state.size = s.dataset.calcSize;
      if (r) state.rush = r.checked;

      const sizeInps = $$('[data-size-qty]');
      if (sizeInps.length) {
        const total = sizeInps.reduce((n, inp) => n + (Math.max(0, parseInt(inp.value) || 0)), 0);
        state.qty = Math.max(1, total);
        const show = $('[data-calc-qty-show]');
        if (show) show.textContent = total + ' pcs';
        const hidden = $('[data-calc-qty]');
        if (hidden) hidden.value = total;
      } else {
        const q = $('[data-calc-qty]');
        if (q) state.qty = Math.max(1, parseInt(q.value, 10) || 1);
      }
    }

    function compute() {
      const garment = BULK_PRICING.garments[state.garment];
      const method = BULK_PRICING.methods[state.method];
      if (!garment || !method) return;

      const garmentUnit = pickTier(garment.tiers, state.qty);
      const methodUnit = pickTier(method.sizes[state.size], state.qty);
      const unitPrice = garmentUnit + methodUnit;
      let subtotal = unitPrice * state.qty;
      const rushFee = state.rush ? Math.round(subtotal * 0.25) : 0;
      const total = subtotal + rushFee;

      // Show what the per-unit would be at 1 to highlight savings
      const at1 = pickTier(garment.tiers, 1) + pickTier(method.sizes[state.size], 1);
      const saving = (at1 - unitPrice) * state.qty;

      const numEl = $('[data-calc-total]');
      const perEl = $('[data-calc-per]');
      const garmentEl = $('[data-calc-garment-line]');
      const methodEl = $('[data-calc-method-line]');
      const qtyEl = $('[data-calc-qty-line]');
      const rushEl = $('[data-calc-rush-line]');
      const saveEl = $('[data-calc-saving]');

      if (numEl) numEl.textContent = money(total);
      if (perEl) perEl.textContent = money(unitPrice) + ' per piece';
      if (garmentEl) garmentEl.textContent = (state.model || garment.name) + ' × ' + state.qty;
      if (methodEl) methodEl.textContent = method.name + ' · ' + state.size.toUpperCase();
      if (qtyEl) qtyEl.textContent = money(garmentUnit * state.qty) + ' garments + ' + money(methodUnit * state.qty) + ' print';
      if (rushEl) rushEl.textContent = state.rush ? '+25% rush · ' + money(rushFee) : '—';
      if (saveEl && saving > 0) {
        saveEl.textContent = 'You save ' + money(saving) + ' vs. ordering 1 at a time';
        saveEl.style.display = '';
      } else if (saveEl) {
        saveEl.style.display = 'none';
      }

      // Update volume tier bar
      const tierBreaks = [1, 10, 25, 50, 100];
      $$('.calc__tier-item').forEach((ti, i) => {
        const min = tierBreaks[i];
        const max = tierBreaks[i + 1] ?? Infinity;
        ti.classList.toggle('calc__tier-item--active', state.qty >= min && state.qty < max);
      });

      // Sticky price bar (mobile-first) — mirrors the live estimate
      const stTotal = $('[data-calc-sticky-total]');
      const stPer = $('[data-calc-sticky-per]');
      if (stTotal) stTotal.textContent = money(total);
      if (stPer) stPer.textContent = money(unitPrice) + '/pc · ' + state.qty + ' pcs';
    }

    // Bind option buttons
    $$('[data-calc-garment]').forEach(b => {
      b.addEventListener('click', () => {
        $$('[data-calc-garment]').forEach(x => x.classList.remove('is-active'));
        b.classList.add('is-active');
        read(); buildModels(); compute();
      });
    });
    $$('[data-calc-method]').forEach(b => {
      b.addEventListener('click', () => {
        $$('[data-calc-method]').forEach(x => x.classList.remove('is-active'));
        b.classList.add('is-active');
        read(); compute();
      });
    });
    $$('[data-calc-size]').forEach(b => {
      b.addEventListener('click', () => {
        $$('[data-calc-size]').forEach(x => x.classList.remove('is-active'));
        b.classList.add('is-active');
        read(); compute();
      });
    });
    // Size breakdown inputs
    $$('[data-size-qty]').forEach(inp => {
      inp.addEventListener('input', () => { read(); compute(); });
    });

    // Quick-fill presets: distribute qty across M/L/XL/S using a typical size curve
    const SIZE_DIST = {
      10:  { XS:0, S:2,  M:4,  L:3,  XL:1, '2XL':0 },
      25:  { XS:0, S:5,  M:10, L:7,  XL:3, '2XL':0 },
      50:  { XS:2, S:10, M:18, L:13, XL:6, '2XL':1 },
      100: { XS:3, S:20, M:37, L:27, XL:10,'2XL':3 },
      250: { XS:8, S:50, M:93, L:68, XL:25,'2XL':6 }
    };
    $$('[data-size-preset]').forEach(btn => {
      btn.addEventListener('click', () => {
        const total = parseInt(btn.dataset.sizePreset);
        const dist = SIZE_DIST[total] || {};
        $$('[data-size-qty]').forEach(inp => {
          inp.value = dist[inp.dataset.sizeQty] ?? 0;
        });
        read(); compute();
      });
    });

    // Fallback: plain qty input (used when no size inputs exist)
    const qInput = $('[data-calc-qty]:not([type=hidden])');
    if (qInput) {
      qInput.addEventListener('input', () => { read(); compute(); });
    }
    const rush = $('[data-calc-rush]');
    if (rush) rush.addEventListener('change', () => { read(); compute(); });

    // Submit form: just show toast in preview
    const form = $('[data-calc-form]');
    if (form) {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const fd = new FormData(form);
        const email = fd.get('email');
        if (!email) { toast('Add your email so we can reply'); return; }
        toast('Quote sent. We reply within 4 business hours.');
        form.reset();
      });
    }

    // Hide the sticky bar while the real summary card is on screen
    const stickyBar = $('[data-calc-sticky]');
    const summaryEl = $('.calc__summary-inner');
    if (stickyBar && summaryEl && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        stickyBar.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0.2 }).observe(summaryEl);
    }

    read(); buildModels(); compute();
  }

  /* ---------- Two-step garment type selector ---------- */
  function bindTypeSelector() {
    const typeGrid    = document.getElementById('cz-type-grid');
    const variantSec  = document.getElementById('cz-variant-section');
    const backBtn     = document.getElementById('cz-back-btn');
    const typeLabel   = document.getElementById('cz-type-label');
    if (!typeGrid || !variantSec) return;

    document.querySelectorAll('[data-type]').forEach(card => {
      card.addEventListener('click', () => {
        const type  = card.dataset.type;
        const label = card.dataset.label || type;

        // Filter garment cards to show only this category
        document.querySelectorAll('[data-garment]').forEach(gc => {
          gc.classList.toggle('is-hidden', gc.dataset.cat !== type);
        });

        if (typeLabel) typeLabel.textContent = label;
        typeGrid.style.display = 'none';
        variantSec.style.display = '';

        // Auto-select first visible garment
        const first = variantSec.querySelector('[data-garment]:not(.is-hidden)');
        if (first) first.click();

        // Scroll to step 01 top
        const step = document.getElementById('step-01');
        if (step) {
          if (window.PTAH && PTAH.lenis) { PTAH.lenis.scrollTo(step, { offset: 0 }); }
          else { step.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        }
      });
    });

    if (backBtn) {
      backBtn.addEventListener('click', () => {
        variantSec.style.display = 'none';
        typeGrid.style.display = '';
        const step = document.getElementById('step-01');
        if (step) {
          if (window.PTAH && PTAH.lenis) { PTAH.lenis.scrollTo(step, { offset: 0 }); }
          else { step.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        }
      });
    }
  }

  /* ---------- Init ---------- */
  /* ---------- Shop: category filter + sorting ---------- */
  function initShopFilters() {
    const grid = $('.grid-shop');
    if (!grid) return;
    const chips = $$('[data-shop-cat]');
    if (!chips.length) return;
    const cards = $$('.pc', grid).filter(c => !c.hasAttribute('hidden'));
    const countEl = $('[data-shop-count]');
    const sortSel = $('[data-shop-sort]');
    let cat = 'all';

    function apply() {
      let visible = 0;
      cards.forEach(c => {
        const show = cat === 'all' || c.dataset.cat === cat;
        c.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible + ' product' + (visible !== 1 ? 's' : '');
    }
    function sortBy(mode) {
      const arr = cards.slice();
      if (mode === 'price-asc')  arr.sort((a, b) => (+a.dataset.price || 0) - (+b.dataset.price || 0));
      if (mode === 'price-desc') arr.sort((a, b) => (+b.dataset.price || 0) - (+a.dataset.price || 0));
      if (mode === 'newest')     arr.sort((a, b) => (+(b.dataset.new || 0)) - (+(a.dataset.new || 0)));
      // 'featured' = original DOM order (cards array keeps it)
      arr.forEach(c => grid.appendChild(c));
    }
    chips.forEach(ch => {
      ch.addEventListener('click', () => {
        chips.forEach(x => x.classList.remove('is-active'));
        ch.classList.add('is-active');
        cat = ch.dataset.shopCat;
        apply();
      });
    });
    if (sortSel) sortSel.addEventListener('change', () => sortBy(sortSel.value));

    // deep links from the footer: shop.html?cat=tees|hoodies|sweatshirts|caps|polos
    const q = new URLSearchParams(location.search).get('cat');
    const map = { tees: 'tee', hoodies: 'hoodie', sweatshirts: 'sweat', caps: 'cap', polos: 'polo', longsleeves: 'ls' };
    if (q && map[q]) {
      const target = chips.find(ch => ch.dataset.shopCat === map[q]);
      if (target) target.click();
    } else {
      apply();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindDrawer('cart-drawer');
    bindDrawer('mobile-menu');
    initShopFilters();
    bindCollapses();
    bindQty();
    bindProductForm();
    bindStickyATC();
    $$('[data-variant-picker]').forEach(p => new VariantPicker(p));
    if (document.querySelector('[data-product-form]')) { window._ptahPricer = new PtahPricer(); }
    refreshCartUI();
    initReveal();
    initRevealStagger();
    initStagger();
    initParallax();
    initCounters();
    initMarquee();
    initHeaderScroll();
    initBulkCalc();
    bindTypeSelector();
    bindGarmentSwitcher();
    bindViewPicker();
    bindLiveLabels();
  });
})();
